module.exports = __webpack_public_path__ + "img/ejymjpg.32e4d985.jpg";